import { Box, Image, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { staticStrings } from '../../static/staticStrings'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'
import { PayAnyOneAnyWhereAnimation } from './PayAnyWhereAnimation'

export const PayAnyOneAnyWhere = ({
  expandAnimation,
  collapseAnimation,
  setPayAnyWhereHeight,
  setPayAnyWhereOffset,
}: any) => {
  const resPadding = usePadding()
  const viewportWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewportWidth)
  return (
    <Box ph={resPadding} pv={isMob ? 56 : 108}>
      <Box w={isMob ? undefined : '90vh'} alignSelf={'center'}>
        <Text
          title={staticStrings.consumerPayAnywhere}
          fontFamily={'jiotype-black'}
          fontSize={isMob ? 24 : 64}
          lineHeight={isMob ? 36 : 80}
          letterSpacing={isMob ? 0 : -2.5}
          textAlign={'center'}
        />
        <Spacer size={24} />
        <Text
          title={staticStrings.payAnywhereSubTitle}
          fontFamily={isMob ? 'jiotype-medium' : 'jiotype-light'}
          fontSize={isMob ? 14 : 24}
          lineHeight={isMob ? 20 : 40}
          letterSpacing={isMob ? 0 : -0.48}
          color={isMob ? 'BLACK_75' : 'BLACK_21'}
          textAlign={'center'}
        />
      </Box>

      <Spacer size={isMob ? 32 : 45} />
      <Box
        flexDirection={'row'}
        justify={'center'}
        align={'center'}
        onLayout={(evt: any) => [
          setPayAnyWhereOffset(evt?.nativeEvent?.layout?.top),
          setPayAnyWhereHeight(evt?.nativeEvent?.layout?.height),
        ]}>
        <PayAnyOneAnyWhereAnimation
          src={require('../../assets/images/kirana.png')}
          width={isMob ? 58 : 128}
          height={isMob ? 58 : 128}
          animationWidth={isMob ? 102 : 250}
          expandAnimation={expandAnimation}
          collapseAnimation={collapseAnimation}
        />
        <Box marginLeft={-16}>
          <PayAnyOneAnyWhereAnimation
            src={require('../../assets/images/chaiwala.png')}
            width={isMob ? 64 : 144}
            height={isMob ? 64 : 144}
            animationWidth={isMob ? 48 : 140}
            expandAnimation={expandAnimation}
            collapseAnimation={collapseAnimation}
          />
        </Box>
        <Box marginLeft={-16} zIndex={10}>
          <Image source={require('../../assets/images/heart.png')} width={isMob ? 72 : 160} height={isMob ? 72 : 160} />
        </Box>
        <Box marginLeft={-16} zIndex={1}>
          <PayAnyOneAnyWhereAnimation
            src={require('../../assets/images/grocery.png')}
            width={isMob ? 64 : 144}
            height={isMob ? 64 : 144}
            animationWidth={isMob ? -48 : -140}
            expandAnimation={expandAnimation}
            collapseAnimation={collapseAnimation}
          />
        </Box>
        <Box marginLeft={-16}>
          <PayAnyOneAnyWhereAnimation
            src={require('../../assets/images/bank.png')}
            width={isMob ? 58 : 128}
            height={isMob ? 58 : 128}
            animationWidth={isMob ? -102 : -250}
            expandAnimation={expandAnimation}
            collapseAnimation={collapseAnimation}
          />
        </Box>
      </Box>
    </Box>
  )
}
